import { createContext, useContext } from 'react';
import { CustomColorPalette } from '../types';
import { FluxObject } from '../AgentsSidebar/context';

export interface DataSidebarContextValue {
  isDarkMode: boolean;
  palette: CustomColorPalette;
  activeObjectId?: string;
  onObjectClick: (obj: FluxObject) => void;
}

export const DataSidebarContext = createContext<DataSidebarContextValue | null>(
  null,
);

export const useDataSidebarContext = () => {
  const context = useContext(DataSidebarContext);
  if (!context) {
    throw new Error(
      'DataSidebar components must be used within DataSidebar.Root',
    );
  }
  return context;
};
